import React from 'react';

import GroupRadioButtons from '../GroupRadioButtons';
import GroupCheckboxes from '../GroupCheckboxes';
import GroupOfMore from '../GroupOfMore';

const mapComponent = {
  by: GroupRadioButtons,
  include: GroupCheckboxes,
  more: GroupOfMore,
};

function StructureOptionsGroup(props) {
  // eslint-disable-next-line react/prop-types
  const { group } = props;

  // eslint-disable-next-line react/prop-types
  const id = group.get('id');

  const Component = mapComponent[id];

  if (!Component) {
    Logger.error(`unknown structureOptions group with id: ${id}`);

    return null;
  }

  return (
    <section className="structure-options-dialog-content-group">
      <Component {...props} groupId={id} group={group} />
    </section>
  );
}

export default StructureOptionsGroup;
